import Recharge from './recharge-progressive.page';
import RechargeTab from './recharge-tab/recharge-tab';
import RechargeTabExample from './recharge-tab/recharge-tab.example';
import RechargeRule from './recharge-rule';

// Store
export {useRechargeStore} from './recharge.store';

// Hooks
export {
  useRechargeTabs,
  useRechargeTabsAutoLoad,
  useRechargeTab,
  useActiveRechargeTab,
} from './recharge-tab/recharge-tab.hooks';

// Service
export {
  getActivityPayList,
  updateTabActiveStatus,
  getVipWeekCardConfigList,
  getMultiple,
} from './recharge-tab/recharge-tab.service';

export default Recharge;
export {RechargeTab, RechargeTabExample, RechargeRule};
